/**
 * Platform helpers
 *
 * In the Customer Portal we run both as:
 * - Web app (browser)
 * - Native app via Capacitor (iOS/Android)
 *
 * Keep this file dependency-free (no @capacitor/core import) so it is safe in all builds.
 */

type CapacitorGlobal = {
  isNativePlatform?: () => boolean
  getPlatform?: () => string
  platform?: string
}

function getCapacitorGlobal(): CapacitorGlobal | null {
  if (typeof window === 'undefined') return null
  const cap = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor
  return cap ?? null
}

export function isNativeApp(): boolean {
  const cap = getCapacitorGlobal()
  if (!cap) return false

  if (typeof cap.isNativePlatform === 'function') {
    return Boolean(cap.isNativePlatform())
  }

  if (typeof cap.getPlatform === 'function') {
    return cap.getPlatform() !== 'web'
  }

  if (typeof cap.platform === 'string') {
    return cap.platform !== 'web'
  }

  // If Capacitor exists but we can't detect the platform, assume native.
  return true
}

